import { TopGainerAndLoserData } from '../../lib/models/fundamental/types';

export const TOP_GAINERS_TAB_INDEX = 0;
export const TOP_LOSERS_TAB_INDEX = 1;

type TabListsParams = {
  topGainers: TopGainerAndLoserData[];
  topLosers: TopGainerAndLoserData[];
  activeTabIndex: number;
};

export const getActiveTabStocks = (
  { topGainers, topLosers, activeTabIndex }: TabListsParams,
): TopGainerAndLoserData[] => (activeTabIndex === TOP_GAINERS_TAB_INDEX ? topGainers : topLosers);

/**
 * Each tab reports emptiness for its own list, so switching tabs can flip the
 * no-data state even though the response did not change.
 */
export const getIsNoData = (params: TabListsParams & { isPending: boolean }): boolean => {
  const { topGainers, topLosers, activeTabIndex, isPending } = params;

  if (isPending) {
    return false;
  }

  return getActiveTabStocks({ topGainers, topLosers, activeTabIndex }).length === 0;
};

type InitialTabParams = {
  isTopGainersSelected?: boolean;
  isMobile: boolean;
};

/** Mobile opens on losers unless the card said which tab was clicked. */
export const getInitialTabIndex = ({ isTopGainersSelected, isMobile }: InitialTabParams): number => {
  if (isTopGainersSelected !== undefined) {
    return isTopGainersSelected ? TOP_GAINERS_TAB_INDEX : TOP_LOSERS_TAB_INDEX;
  }

  return isMobile ? TOP_LOSERS_TAB_INDEX : TOP_GAINERS_TAB_INDEX;
};
